export const isNotEmptyString = (str: string) => !!str && typeof str === 'string' && str.trim() !== '';
